import React, { Component } from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './ConfirmationPopup.css';
import cx from 'classnames';
import {
	Modal,
	Button
} from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import messages from '../../../locale/messages';
import rs from '../../storeCommon.css';

export class ConfirmationPopup extends Component {

	static defaultProps = {
		setShow: false
	}

	constructor(props) {
		super(props);
		this.state = {
			show: false,
			setShow: false
		};

	}

	componentDidMount() {
		const { modalStatus } = this.props;
		if (modalStatus === true) {
			this.setState({ setShow: true });
		}
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		const { modalStatus } = nextProps;

		if (modalStatus === true) {
			this.setState({ setShow: true });
		} else {
			this.setState({ setShow: false });
		}
	}

	handleRightButton() {

	}

	render() {
		const {
			checkBookedModifier,
			closeModal,
			title,
			body,
			popupButtonLeftName,
			popupButtonRightName,
			popupButtonLeftFunction,
			popupButtonRightFunction,
			bodyModifier,
			loading
		} = this.props;
		const { setShow } = this.state;

		return (
			<Modal show={setShow} onHide={() => { if (!loading) closeModal(); }} backdrop={loading ? 'static' : true} keyboard={!loading} className={'listItemModal'}>
				<Modal.Header closeButton={!loading}>
					<Modal.Title>{title}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className={rs.title}>
						{checkBookedModifier && bodyModifier}
						{!checkBookedModifier && body}
					</div>
					<div className={cx(rs.alignRightText, 'textAlignLeftRTL')}>
						<div className={cx(rs.displayInlineBlockRes, rs.btnMarginRight, 'displayInlineBlockResRTL')}>
							<Button variant="secondary" disabled={loading} className={cx(rs.button, rs.btnPrimaryBorder, rs.textOverFlow, rs.responsiveBtn)} onClick={() => popupButtonLeftFunction()}>
								{popupButtonLeftName}
							</Button>
						</div>
						<div className={rs.displayInlineBlockRes}>
							<Button variant="primary" disabled={loading} className={cx(rs.button, rs.btnPrimary, rs.textOverFlow, rs.responsiveBtn)} onClick={() => popupButtonRightFunction()}>
								{popupButtonRightName}
								{loading &&
									<span className="spinner-border spinner-border-sm ml-2 me-1" role="status" aria-hidden="true" />
								} 
							</Button>
						</div>
					</div>
				</Modal.Body>
			</Modal>
		)
	}
}

const mapState = state => ({

});

const mapDispatch = {
};

export default injectIntl(withStyles(s, rs)(connect(mapState, mapDispatch)(ConfirmationPopup)));
